import type { ComponentProps } from "react";
import { MapPin } from "lucide-react";
import { Input } from "@/shared/components/shadcn/Input";
import { FormField } from "@/shared/components/ui/FormField";
import { SectionCard } from "@/shared/components/ui/SectionCard";
import { LocationAddressFields } from "./LocationAddressFields";

interface LocationSectionProps {
  value: ComponentProps<typeof LocationAddressFields>["value"] & { name: string };
  onChange: (value: LocationSectionProps["value"]) => void;
}

export function LocationSection({ value, onChange }: LocationSectionProps) {
  return (
    <SectionCard
      title="Location details"
      icon={<MapPin />}
      description="Where you welcome your customers. Address details are optional."
    >
      <div className="space-y-[18px]">
        <FormField id="location-name" label="Location name">
          <Input required pattern=".*\S.*" title="Enter a location name, not just spaces." value={value.name} onChange={(event) => onChange({ ...value, name: event.target.value })} />
        </FormField>
        <LocationAddressFields value={value} onChange={(address) => onChange({ ...value, ...address })} />
      </div>
    </SectionCard>
  );
}
